(function ($) {
	var engrbtn = $(".engineering-btn");
	var manufbtn = $(".manufacturing-btn");
	var suppbtn = $(".support-btn");
	var engrcont = $(".engineering-cont");
	var manufcont = $(".manufacturing-cont");
	var suppcont = $(".support-cont");

	var connectbtn = $('.sticky-connect a');
	var solthumb = $('section.solutions .solutions-content ul > li .sol-thumb a');

	$('.sticky-contact .sticky-toggle').on('click', function () {
		$(this).parents('.sticky-contact').toggleClass('open');
	});

	$('.sticky-contact .close-button').on('click', function () {
		$(this).parents('.sticky-contact').removeClass('open');
	});

	engrbtn.click(function (e) {
		e.preventDefault();
		engrcont.removeClass('hidden');
		engrcont.addClass('show');
		engrbtn.addClass('active');
		suppbtn.removeClass('active');
		suppcont.removeClass('show');
		suppcont.addClass('hidden');
		manufbtn.removeClass('active');
		manufcont.removeClass('show');
		manufcont.addClass('hidden');
	});

	manufbtn.click(function (e) {
		e.preventDefault();
		manufcont.removeClass('hidden');
		manufcont.addClass('show');
		manufbtn.addClass('active');
		engrbtn.removeClass('active');
		engrcont.removeClass('show');
		engrcont.addClass('hidden');
		suppbtn.removeClass('active');
		suppcont.removeClass('show');
		suppcont.addClass('hidden');
	});

	suppbtn.click(function (e) {
		e.preventDefault();
		suppcont.removeClass('hidden');
		suppcont.addClass('show');
		suppbtn.addClass('active');
		engrbtn.removeClass('active');
		engrcont.removeClass('show');
		engrcont.addClass('hidden');
		manufbtn.removeClass('active');
		manufcont.removeClass('show');
		manufcont.addClass('hidden');
	});

	connectbtn.click(function (e) {
		e.preventDefault();
	});

	$('.autoplay').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 2000,
		responsive: [{
				breakpoint: 769,
				settings: {
					slidesToShow: 3,
				}
			},
			{
				breakpoint: 668,
				settings: {
					slidesToShow: 1,
				}
			},
			{
				breakpoint: 426,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				}
			}
		]
	});

	$('.close-button').on('click', function () {
		$('.sticky-contact').removeClass('open');
	});

	$(document).bind("contextmenu", function (e) {
		return false;
	});

	if ($('#splashpage').length) {
		$.fancybox.open({
			src: '#splashpage',
			type: 'inline',
			// opts : {
			//   afterShow : function( instance, current ) {
			//     console.info( 'done!' );
			//   }
			// }
		});
	}

	$('#splashpage a').on('click', function () {
		$.fancybox.close();
	});

	$(document).bind("contextmenu", function (e) {
		return false;
	});

	// Fix the position of the navbar on top
	function fixSitckyNav() {
		var st = $(window).scrollTop();
		var wh = window.innerHeight - (window.innerHeight / 3);
		var mainNav = $('.sticky-storynav');
		// alert(st + ' = ' + wh);
		if (st >= wh) {
			mainNav.addClass('sticky-fix');
		} else {
			mainNav.removeClass('sticky-fix');
		}
	}

	function onScroll(event) {
		var scrollPos = $(document).scrollTop();
		$('.sticky-storynav a').each(function () {
			var currLink = $(this);
			var refElement = $(currLink.attr("href"));
			if (refElement.position().top <= scrollPos && refElement.position().top + refElement.height() > scrollPos) {
				$('.sticky-storynav a').removeClass("active");
				currLink.addClass("active");
			} else {
				currLink.removeClass("active");
			}
		});
	}

	$(document).on("scroll", onScroll);
	//smoothscroll
	$('.sticky-storynav a[href^="#"]').on('click', function (e) {
		e.preventDefault();
		$(document).off("scroll");

		$('.sticky-storynav a').each(function () {
			$(this).removeClass('active');
		})
		$(this).addClass('active');

		var target = this.hash,
			menu = target;
		$target = $(target);
		$('html, body').stop().animate({
			'scrollTop': $target.offset().top + 2
		}, 500, 'swing', function () {
			window.location.hash = target;
			$(document).on("scroll", onScroll);
		});
	});

	fixSitckyNav();
	$(window).scroll(function () {
		fixSitckyNav();
	});

	Drupal.behaviors.applyNow = {
		attach: function (context, settings) {
			$('.applynow .apply-btn', context).click(function () {
				var position = $(this).data('position');
				var emailto = $(this).data('emailto')
				$('#apply-form h2 .pos').text(position);
				$('#apply-form input[name="submitted[position_applied_for]"]').val(position);
				$('#apply-form input[name="submitted[email_to]"]').val(emailto);
			});
		}
	};

	// New scripts for redesign.
	var markets = document.querySelector('.component--markets');
	if (markets) {
		markets.querySelector('.card:first-child .collapse').classList.add('show');
		markets.querySelector('.image-wrapper img').src = markets.querySelector('.card:first-child .title').getAttribute('data-image');

		$('.component--markets .card .title').click(function(e) {
			e.preventDefault();
			markets.querySelector('.image-wrapper img').src = $(this).attr('data-image');
		});
	}

	if ($('.side-menu').length && $('.side-menu').children().length === 0) {
		$('.side-menu').addClass('empty');
	}

	$('a.popup-link').on('click', function(e) {
		e.preventDefault();
		$.fancybox.open({
			src: $(this).attr('href'),
			type: 'inline',
		});
	});

	$('a.back-to-top').on('click', function(e) {
		e.preventDefault();
		window.scrollTo({ top: 0 });
	});

	$('.main-menu > .nav-item a').on('click', function(e) {
		e.stopPropagation();
	});

	$('.main-menu > .nav-item').on('click', function(e) {
		$(this).toggleClass('expand');
	});

})(jQuery);
